import React, { useState, useEffect, useMemo } from 'react'
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { planList } from '../store/plan/actions';
import DataTable from 'react-data-table-component';
import FilterComponent from "./FilterComponent";
import Spinner from "../components/layout/Spinner";

function Plan(props) {
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    props.planList();
  }, [])

  const columns = [
    {
      name: "#",
      width: '60px',
      selector: row => row.serial,
    },
    {
      name: "PLAN NAME",
      width: "600px",
      selector: row => row.PlanName,
    },
    {
      name: "PLAN PRICE",
      selector: row => row.PlanPrice,
    },
    {
      name: "PLAN CATEGORY",
      selector: row => row.PlanCategory,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: '50px', // override the row height
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '0px',
        fontWeight: 'bold',
        fontSize: '14px'
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '0px',
      },
    },
  };

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={e => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const filteredItems = props.plan && props.plan.filter(
    item =>
      JSON.stringify(item)
        .toLowerCase()
        .indexOf(filterText.toLowerCase()) !== -1

  );

  const filterData = filteredItems && filteredItems.map((data, key) => {
    return {
      serial: (<p>{key + 1}</p>),
      PlanName: (<p style={{ "whiteSpace": "break-spaces" }}>{data.PlanName}</p>),
      PlanPrice: (<p>{data.CurrencyCode}{data.PlanPrice}</p>),
      PlanCategory: (<p>{data.PlanCategory}</p>),
    }
  })

  if (props.apiError === 'Invalid token') {
    localStorage.removeItem("authUser");
    localStorage.removeItem("token");
    window.location.href = '/';
  }

  return (
    <div className="nk-block-head-content">
      <h3 className="nk-block-title page-title">Plan</h3>
      <div className="card p-2" style={{ marginTop: '12px' }}>
        <div className="card-inner p-0" >
          <DataTable pagination columns={columns} data={filterData} customStyles={customStyles} progressPending={props.loading} progressComponent={<Spinner />} subHeaderComponent={subHeaderComponent} subHeader responsive striped />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const { plan, apiError, loading } = state.plan;
  return { plan, apiError, loading };
}

// export default Users;
export default withRouter(connect(mapStateToProps, { planList })(Plan));